import { render } from "./TutorialWizard.vue?vue&type=template&id=d1ba1a32&scoped=true"
import script from "./TutorialWizard.vue?vue&type=script&lang=js"
export * from "./TutorialWizard.vue?vue&type=script&lang=js"

import "./TutorialWizard.vue?vue&type=style&index=0&id=d1ba1a32&lang=scss"
import "./TutorialWizard.vue?vue&type=style&index=1&id=d1ba1a32&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ba1a32"]])

export default __exports__